/** PURE_IMPORTS_START .._.._Observable,.._.._operator_multicast PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { multicast } from '../../operator/multicast';
Observable.prototype.multicast = multicast;
//# sourceMappingURL=multicast.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/multicast.js
// module id = 691
// module chunks = 0